export default __webpack_public_path__ + "app/images/ic-check.svg";